import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

export const ParameterizationRecordingComposition = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 60) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(933 / 60) * fps}
			style={{
				width: 2032,
				height: 1440,
			}}
		>
			<Video
				src={
					'https://remotion.media/explore-remotion/parameterization-source-2026-10-20-cc659ab7d29a.mp4'
				}
				durationInFrames={(933 / 60) * fps}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={
					(frame >= 417 && frame < 549) || (frame >= 678 && frame < 778)
						? 'ew-resize'
						: interpolate(
								frame,
								[
									11, 38, 39, 48, 88, 95, 172, 223, 281, 291, 320, 391, 405,
									447, 449, 617, 619, 648, 651, 779, 789, 833, 834, 835, 842,
									844, 846, 847,
								],
								[
									'auto',
									'col-resize',
									'auto',
									'default',
									'auto',
									'default',
									'auto',
									'default',
									'auto',
									'default',
									'auto',
									'default',
									'ew-resize',
									'default',
									'ew-resize',
									'default',
									'auto',
									'default',
									'ew-resize',
									'auto',
									'default',
									'auto',
									'col-resize',
									'auto',
									'default',
									'auto',
									'row-resize',
									'auto',
								],
								{
									easing: Easing.step1,
									extrapolateLeft: 'clamp',
									extrapolateRight: 'clamp',
								},
							)
				}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[
							0, 64, 71, 144, 151, 247, 255, 335, 342, 417, 549, 678, 778, 884,
							889,
						],
						[
							3.714256926952141, 3.342831234256927, 3.714256926952141,
							3.342831234256927, 3.714256926952141, 3.342831234256927,
							3.714256926952141, 3.342831234256927, 3.714256926952141,
							3.342831234256927, 3.714256926952141, 3.342831234256927,
							3.714256926952141, 3.342831234256927, 3.714256926952141,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26,
							27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42,
							43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
							59, 60, 61, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99,
							100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112,
							113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125,
							126, 127, 128, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180,
							181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193,
							194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206,
							207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219,
							220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 280,
							281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293,
							294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 316, 317,
							318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330,
							331, 332, 333, 334, 335, 336, 358, 359, 360, 361, 362, 363, 364,
							365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377,
							378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388, 389, 390,
							391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401, 402, 403,
							404, 405, 406, 407, 408, 409, 410, 411, 412, 438, 439, 440, 441,
							442, 443, 446, 447, 448, 449, 450, 451, 452, 453, 454, 455, 456,
							457, 458, 459, 460, 461, 462, 463, 464, 465, 466, 467, 468, 469,
							470, 471, 472, 473, 474, 475, 476, 477, 478, 479, 481, 482, 483,
							484, 485, 486, 488, 489, 490, 491, 492, 493, 494, 495, 496, 497,
							498, 499, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510,
							511, 512, 513, 514, 515, 516, 517, 518, 519, 520, 521, 522, 523,
							524, 525, 526, 527, 528, 530, 531, 616, 617, 618, 619, 620, 621,
							622, 623, 624, 625, 626, 627, 628, 629, 630, 631, 632, 633, 634,
							635, 636, 637, 638, 639, 640, 641, 642, 643, 644, 645, 646, 647,
							648, 649, 650, 651, 652, 653, 654, 655, 656, 657, 658, 659, 660,
							662, 663, 699, 700, 701, 702, 703, 704, 705, 706, 707, 708, 709,
							710, 711, 712, 713, 714, 715, 716, 717, 718, 719, 720, 721, 722,
							723, 724, 725, 726, 727, 728, 729, 730, 731, 732, 733, 734, 735,
							736, 737, 738, 739, 740, 741, 742, 743, 744, 745, 746, 747, 748,
							749, 750, 751, 752, 753, 754, 755, 756, 757, 758, 759, 760, 761,
							762, 764, 765, 766, 767, 776, 777, 778, 779, 780, 781, 782, 783,
							784, 785, 786, 787, 788, 789, 790, 829, 830, 831, 832, 833, 834,
							835, 836, 837, 838, 839, 840, 841, 842, 843, 844, 845, 846, 847,
							848, 849, 850, 851, 852, 853, 854, 855, 856, 857, 858, 859, 860,
							861, 862, 863, 864, 865, 866, 867, 868, 869, 870, 871, 872, 873,
							874, 875, 876, 877, 878, 879, 880, 881, 882, 883,
						],
						[
							'-460.3792443324937px 1873.4798992443325px',
							'-396.1342065491184px 1791.4325440806044px',
							'-307.0355667506297px 1696.559395465995px',
							'-146.93078085642318px 1553.4444332493704px',
							'12.172896725440806px 1425.0123929471033px',
							'185.23405541561712px 1276.8918891687658px',
							'320.93501259445844px 1116.7580856423174px',
							'417.78136020151135px 999.9330982367758px',
							'463.600201511335px 936.9213098236776px',
							'505.0954156171285px 864.2611586901763px',
							'529.6733501259446px 815.0472544080604px',
							'541.4254911838791px 772.6379848866499px',
							'552.0894710327456px 737.0333501259446px',
							'558.6619647355163px 707.1451889168766px',
							'567.7154659949622px 682.9735012594458px',
							'572.6774811083123px 668.0584382871536px',
							'576.5658438287154px 660.223677581864px',
							'577.9731989924434px 657.3799496221662px',
							'577.9731989924434px 656.3062972292191px',
							'581.8615617128463px 648.4715365239294px',
							'601.0567254408061px 630.335516372796px',
							'629.5230226700252px 605.4093702770781px',
							'652.8096725440806px 582.0937027707809px',
							'676.096322418136px 558.7780352644836px',
							'697.424282115869px 530.2827204030227px',
							'712.5134508816121px 509.12886649874054px',
							'730.6204534005037px 490.99284634760704px',
							'748.7274559193954px 472.85682619647355px',
							'775.0319395465995px 456.128161209068px',
							'796.1567758186397px 441.0099748110831px',
							'812.6532997481108px 426.96544080604536px',
							'823.99919395466px 418.07153652392947px',
							'831.8049370277078px 410.2367758186398px',
							'839.6106801007556px 404.3607052896725px',
							'847.4164231738035px 398.48463476070526px',
							'853.263476070529px 390.64987405541564px',
							'859.1105289672544px 382.81511335012596px',
							'864.4207556675063px 377.47586901763225px',
							'870.2678085642317px 369.64110831234257px',
							'878.0735516372796px 365.7237279596977px',
							'885.8792947103275px 361.8063476070529px',
							'891.7263476070528px 355.9302770780856px',
							'900.9394458438287px 348.6323425692695px',
							'906.2496725440806px 346.6736523929471px',
							'909.0643828715365px 345.2517884130982px',
							'911.8790931989925px 345.2517884130982px',
							'914.6938035264484px 345.2517884130982px',
							'917.5085138539043px 343.82992443324935px',
							'920.0765743073048px 343.82992443324935px',
							'920.0765743073048px 343.82992443324935px',
							'921.1357178841309px 343.82992443324935px',
							'921.1357178841309px 343.82992443324935px',
							'921.1357178841309px 346.58659949622165px',
							'921.1357178841309px 357.9324937027708px',
							'921.1357178841309px 361.83536523929473px',
							'921.1357178841309px 369.64110831234257px',
							'921.1357178841309px 380.9870025188917px',
							'917.2183375314861px 388.79274559193954px',
							'912.7641309823678px 400.13863979848867px',
							'907.7876070528968px 411.4845340050378px',
							'903.8702267002519px 426.7332997481108px',
							'901.9115365239295px 434.5390428211587px',
							'901.9115365239295px 445.8849370277078px',
							'899.4160201511335px 457.2308312342569px',
							'891.9439798488665px 472.1168765743073px',
							'886.416120906801px 491.631234256927px',
							'881.425088161209px 506.51727959697735px',
							'872.3425692695214px 530.6599496221662px',
							'866.8147103274559px 550.1743073047859px',
							'864.3191939546599px 569.6886649874056px',
							'861.2868513853904px 589.2030226700252px',
							'856.2958186397985px 604.0890680100756px',
							'853.8003022670025px 618.975113350126px',
							'846.3282619647355px 633.8611586901764px',
							'841.3372292191435px 648.7472040302267px',
							'838.8417128463476px 660.0930982367759px',
							'833.8506801007557px 676.0673047858942px',
							'831.3551637279597px 690.9533501259446px',
							'829.3964735516373px 702.2992443324937px',
							'826.9009571788413px 717.1852896725441px',
							'822.9835768261964px 724.991032745592px',
							'821.024886649874px 732.7967758186398px',
							'818.1811586901763px 739.5143576826197px',
							'816.7592947103275px 740.9217128463476px',
							'816.7592947103275px 742.3290680100756px',
							'816.7592947103275px 743.4897732997481px',
							'816.7592947103275px 744.6504785894207px',
							'816.7592947103275px 745.7096221662468px',
							'815.584080604534px 746.8703274559194px',
							'814.4088664987405px 749.4383879093199px',
							'812.9870025188917px 750.8457430730479px',
							'812.9870025188917px 752.0064483627204px',
							'811.5651385390428px 754.4729471032746px',
							'811.5651385390428px 754.4729471032746px',
							'811.5651385390428px 753.5734005037783px',
							'811.5651385390428px 745.7386397984886px',
							'811.5651385390428px 741.8212594458438px',
							'811.5651385390428px 733.9864987405541px',
							'811.5651385390428px 728.6472544080605px',
							'812.9724937027707px 723.3080100755667px',
							'812.9724937027707px 717.968765743073px',
							'814.3798488664987px 715.1250377833753px',
							'815.7872040302267px 709.7857934508816px',
							'819.6755667506297px 700.5291687657431px',
							'824.1007556675063px 689.1542569269521px',
							'826.0449370277078px 677.7793450881612px',
							'830.4701259445844px 666.4044332493703px',
							'834.895314861461px 655.0295214105794px',
							'836.8394962216624px 647.1947607052897px',
							'840.7278589420655px 639.36px',
							'844.0793954659949px 634.0207556675063px',
							'846.0235768261965px 628.6815113350126px',
							'847.4309319899244px 625.8377833753149px',
							'850.2456423173803px 622.9940554156171px',
							'853.0603526448363px 620.1503274559194px',
							'854.4677078085642px 617.3065994962217px',
							'857.2824181360202px 614.462871536524px',
							'858.6897732997481px 611.6191435768262px',
							'861.2578337531486px 609.0220654911839px',
							'861.2578337531486px 607.9484130982368px',
							'862.6651889168766px 607.9484130982368px',
							'863.8258942065492px 607.9484130982368px',
							'864.9865994962216px 607.9484130982368px',
							'864.9865994962216px 607.9484130982368px',
							'865.9731989924434px 607.9484130982368px',
							'868.7879093198992px 607.9484130982368px',
							'872.1394458438288px 611.8512846347608px',
							'876.0278085642317px 619.6570277078085px',
							'878.8425188916876px 622.4717380352645px',
							'880.2498740554156px 625.2864483627204px',
							'880.2498740554156px 628.1011586901764px',
							'880.2498740554156px 633.4113853904282px',
							'882.1940554156171px 638.7216120906801px',
							'882.1940554156171px 642.624483627204px',
							'884.1382367758187px 650.4302267002519px',
							'886.0824181360201px 658.2359697732998px',
							'886.0824181360201px 663.5461964735516px',
							'888.0265994962217px 668.8564231738035px',
							'889.4339546599496px 671.6711335012594px',
							'890.8413098236775px 674.4858438287154px',
							'892.7854911838791px 682.2915869017633px',
							'894.7296725440806px 687.6018136020151px',
							'896.1370277078086px 692.912040302267px',
							'897.5443828715365px 695.7267506297229px',
							'899.488564231738px 701.0369773299748px',
							'900.895919395466px 710.2500755667506px',
							'902.8401007556675px 718.0558186397985px',
							'904.2474559193955px 720.8705289672544px',
							'904.2474559193955px 722.2778841309823px',
							'907.598992443325px 731.4909823677582px',
							'909.0063476070529px 734.3056926952141px',
							'911.8210579345088px 737.1204030226701px',
							'911.8210579345088px 739.9351133501259px',
							'913.2284130982367px 741.0958186397985px',
							'913.2284130982367px 741.0958186397985px',
							'913.2284130982367px 745.8837279596977px',
							'913.2284130982367px 753.6894710327456px',
							'911.2697229219143px 758.9996977329974px',
							'911.2697229219143px 766.8054408060453px',
							'907.8891687657431px 772.1156675062972px',
							'907.8891687657431px 776.0185390428212px',
							'903.0867506297229px 782.736120906801px',
							'901.664886649874px 788.0463476070529px',
							'900.2430226700252px 790.8610579345088px',
							'898.8211586901763px 796.1712846347607px',
							'898.8211586901763px 801.4815113350126px',
							'897.3992947103275px 806.7917380352645px',
							'895.9774307304785px 809.6064483627204px',
							'895.9774307304785px 812.4211586901763px',
							'895.9774307304785px 813.8285138539043px',
							'894.9473047858942px 814.8441309823678px',
							'894.9473047858942px 814.8441309823678px',
							'893.5254408060454px 818.8195465994962px',
							'892.1035768261964px 821.6342569269522px',
							'892.1035768261964px 824.4489672544081px',
							'890.6817128463476px 827.2636775818639px',
							'890.6817128463476px 830.0783879093199px',
							'890.6817128463476px 831.2390931989925px',
							'890.6817128463476px 832.3997984886649px',
							'890.6817128463476px 832.3997984886649px',
							'894.5845843828715px 829.5270528967254px',
							'907.5409571788413px 816.5416624685139px',
							'928.6657934508817px 801.423476070529px',
							'954.9702770780856px 784.6948110831235px',
							'984.8294206549118px 771.52080604534px',
							'1002.6172292191436px 767.951637279597px',
							'1038.192846347607px 757.2586397984886px',
							'1062.335516372796px 751.1939546599497px',
							'1081.8498740554155px 745.6660957178841px',
							'1096.735919395466px 740.6750629722922px',
							'1108.081813602015px 738.1795465994962px',
							'1119.4277078085643px 736.2208564231738px',
							'1131.136322418136px 734.2621662468514px',
							'1142.4822166246852px 731.7666498740554px',
							'1150.287959697733px 731.7666498740554px',
							'1153.102670025189px 730.3447858942066px',
							'1155.9173803526448px 730.3447858942066px',
							'1158.7320906801008px 730.3447858942066px',
							'1160.1394458438288px 730.3447858942066px',
							'1160.734307304786px 730.3447858942066px',
							'1160.734307304786px 730.3447858942066px',
							'1160.734307304786px 732.1583879093199px',
							'1158.23879093199px 743.504282115869px',
							'1155.7432745591939px 750.9473047858942px',
							'1151.2890680100757px 762.2931989924433px',
							'1147.3716876574308px 770.0989420654912px',
							'1141.4956171284634px 777.9046851385391px',
							'1135.6195465994963px 783.7517380352645px',
							'1130.2803022670025px 789.0619647355164px',
							'1124.9410579345088px 792.4135012594459px',
							'1117.106297229219px 798.2605541561713px',
							'1111.230226700252px 806.0662972292191px',
							'1099.855314861461px 812.4501763224181px',
							'1092.0205541561713px 818.2972292191436px',
							'1082.227103274559px 828.0471536523929px',
							'1076.351032745592px 835.8528967254408px',
							'1068.5162720403023px 841.6999496221663px',
							'1058.72282115869px 851.4498740554156px',
							'1054.8054408060452px 855.3527455919395px',
							'1046.9706801007558px 861.199798488665px',
							'1041.0946095717884px 867.0468513853905px',
							'1035.7553652392946px 870.3983879093199px',
							'1030.416120906801px 873.7499244332494px',
							'1027.5723929471033px 876.5646347607053px',
							'1022.2331486146096px 879.9161712846347px',
							'1019.3894206549119px 882.7308816120907px',
							'1016.5456926952141px 885.5455919395466px',
							'1013.9486146095718px 888.1136523929471px',
							'1011.1048866498741px 889.521007556675px',
							'1009.6830226700251px 890.928362720403px',
							'1006.8392947103274px 893.743073047859px',
							'1003.9955667506297px 896.5577833753149px',
							'1001.151838790932px 899.3724937027707px',
							'995.8125944584383px 902.7240302267003px',
							'990.4733501259445px 906.0755667506297px',
							'985.1341057934509px 909.4271032745592px',
							'979.2580352644836px 915.2741561712846px',
							'976.4143073047859px 918.0888664987406px',
							'974.992443324937px 919.4962216624685px',
							'970.7268513853904px 922.3109319899245px',
							'967.8831234256927px 923.7182871536523px',
							'965.039395465995px 925.1256423173803px',
							'955.7827707808564px 926.5329974811083px',
							'950.4435264483627px 927.9403526448363px',
							'947.599798488665px 929.3477078085642px',
							'942.2605541561713px 930.7550629722922px',
							'939.4168261964735px 932.1624181360202px',
							'934.0775818639798px 933.5697732997481px',
							'931.2338539042821px 933.5697732997481px',
							'928.3901259445844px 934.9771284634761px',
							'925.5463979848867px 934.9771284634761px',
							'922.7026700251889px 936.3844836272041px',
							'921.28080604534px 936.3844836272041px',
							'920.1055919395466px 936.3844836272041px',
							'919.0319395465995px 936.3844836272041px',
							'919.0319395465995px 936.3844836272041px',
							'919.4672040302268px 936.3844836272041px',
							'919.4672040302268px 936.3844836272041px',
							'926.1557682619647px 941.2739546599496px',
							'926.1557682619647px 941.2739546599496px',
							'931.9157682619648px 944.1321914357683px',
							'931.9157682619648px 944.1321914357683px',
							'940.8822166246852px 949.2828211586901px',
							'940.8822166246852px 949.2828211586901px',
							'945.0027204030226px 950.7917380352645px',
							'945.0027204030226px 950.7917380352645px',
							'947.8319395465995px 951.5461964735516px',
							'949.2247858942065px 951.5897229219144px',
							'951.9089168765743px 951.5897229219144px',
							'951.9089168765743px 951.5897229219144px',
							'953.1131486146096px 952.1700755667506px',
							'955.4345591939547px 952.750428211587px',
							'956.4937027707808px 952.750428211587px',
							'958.8006045340051px 952.750428211587px',
							'958.8006045340051px 952.750428211587px',
							'961.4121914357682px 952.750428211587px',
							'961.4121914357682px 952.750428211587px',
							'964.0237783375314px 952.750428211587px',
							'965.184483627204px 952.750428211587px',
							'965.184483627204px 952.750428211587px',
							'966.2871536523929px 952.750428211587px',
							'968.5795465994962px 952.750428211587px',
							'969.6967254408061px 952.750428211587px',
							'977.952241813602px 952.750428211587px',
							'977.952241813602px 952.750428211587px',
							'992.4465491183879px 952.750428211587px',
							'992.4465491183879px 952.750428211587px',
							'997.2489672544081px 952.750428211587px',
							'997.2489672544081px 952.750428211587px',
							'998.511234256927px 952.750428211587px',
							'998.511234256927px 952.750428211587px',
							'1002.6027204030227px 952.750428211587px',
							'1005.4174307304786px 952.750428211587px',
							'1005.4174307304786px 952.750428211587px',
							'1007.6953148614609px 952.750428211587px',
							'1007.6953148614609px 952.750428211587px',
							'1008.8850377833753px 952.750428211587px',
							'1008.8850377833753px 952.750428211587px',
							'1011.2499748110831px 952.750428211587px',
							'1011.2499748110831px 952.750428211587px',
							'1012.3381360201512px 952.750428211587px',
							'1012.3381360201512px 952.750428211587px',
							'1013.3102267002519px 952.750428211587px',
							'1014.2823173803527px 952.750428211587px',
							'1015.3994962216625px 952.750428211587px',
							'1015.3994962216625px 952.750428211587px',
							'1019.3749118387909px 951.4591435768262px',
							'1022.2186397984887px 951.2995465994962px',
							'1022.2186397984887px 951.2995465994962px',
							'1026.4697229219144px 951.2560201511335px',
							'1030.72080604534px 949.8196473551637px',
							'1033.2308312342568px 949.8196473551637px',
							'1036.0745591939547px 949.8196473551637px',
							'1036.0745591939547px 949.8196473551637px',
							'1048.9728967254407px 949.007153652393px',
							'1048.9728967254407px 949.007153652393px',
							'1058.7083123425693px 947.8464483627204px',
							'1058.7083123425693px 947.8464483627204px',
							'1063.1770277078085px 947.8464483627204px',
							'1066.064282115869px 947.8464483627204px',
							'1070.3008564231739px 946.4245843828716px',
							'1070.3008564231739px 946.4245843828716px',
							'1075.6110831234257px 946.4245843828716px',
							'1080.689168765743px 945.3944584382872px',
							'1080.689168765743px 945.3944584382872px',
							'1084.9692695214105px 945.0027204030226px',
							'1089.3509319899244px 943.6969269521411px',
							'1089.3509319899244px 943.6969269521411px',
							'1093.790629722922px 943.5083123425693px',
							'1093.790629722922px 943.5083123425693px',
							'1102.0606549118388px 942.0574307304786px',
							'1108.8507808564232px 942.0284130982368px',
							'1115.263677581864px 942.0284130982368px',
							'1115.263677581864px 942.0284130982368px',
							'1118.1074055415618px 942.0284130982368px',
							'1120.559395465995px 941.0273047858942px',
							'1120.559395465995px 941.0273047858942px',
							'1124.7234256926952px 940.911234256927px',
							'1127.6542065491183px 940.8822166246852px',
							'1127.6542065491183px 940.8822166246852px',
							'1129.728967254408px 940.1857934508816px',
							'1130.338337531486px 939.4748614609572px',
							'1130.338337531486px 939.4748614609572px',
							'1131.4119899244333px 939.4313350125944px',
							'1131.4119899244333px 939.4313350125944px',
							'1124.6363727959697px 947.759395465995px',
							'1106.5003526448363px 965.8663979848867px',
							'1097.4323425692696px 974.9198992443324px',
							'1071.83879093199px 997.9889168765743px',
							'1044.6347607052896px 1025.1494206549119px',
							'1024.8882619647354px 1048.4360705289673px',
							'1008.3627204030226px 1062.4515869017632px',
							'995.9286649874056px 1074.8566246851385px',
							'990.9521410579345px 1082.2996473551636px',
							'983.1173803526449px 1088.1467002518891px',
							'971.3652392947104px 1095.9379345088162px',
							'963.5304785894207px 1099.826297229219px',
							'958.1912342569269px 1101.7704785894207px',
							'952.8519899244333px 1101.7704785894207px',
							'945.0172292191436px 1101.7704785894207px',
							'939.6779848866498px 1101.7704785894207px',
							'931.8432241813601px 1097.8530982367758px',
							'925.967153652393px 1090.0183375314862px',
							'920.976120906801px 1075.103274559194px',
							'915.9850881612091px 1060.1882115869018px',
							'914.0263979848867px 1044.1849874055415px',
							'914.0263979848867px 1029.2699244332493px',
							'914.0263979848867px 1017.8950125944584px',
							'914.0263979848867px 1010.0602518891687px',
							'914.0263979848867px 1000.8036272040302px',
							'914.0263979848867px 995.4643828715365px',
							'914.0263979848867px 992.6206549118388px',
							'914.0263979848867px 987.2814105793451px',
							'914.0263979848867px 981.9421662468513px',
							'914.0263979848867px 976.6029219143577px',
							'914.0263979848867px 973.75919395466px',
							'914.0263979848867px 968.4199496221662px',
							'914.0263979848867px 965.5762216624685px',
							'914.0263979848867px 962.9791435768262px',
							'914.0263979848867px 961.5572795969773px',
							'914.0263979848867px 960.1354156171285px',
							'915.4337531486146px 957.5383375314861px',
							'916.8411083123426px 956.1164735516372px',
							'918.0018136020151px 954.9412594458438px',
							'919.1625188916877px 953.7805541561713px',
							'919.1625188916877px 952.3586901763224px',
							'920.2216624685138px 951.2850377833753px',
							'920.2216624685138px 951.2850377833753px',
							'920.2216624685138px 950.2113853904282px',
							'920.2216624685138px 950.2113853904282px',
							'920.2216624685138px 949.2392947103275px',
							'920.2216624685138px 949.2392947103275px',
							'920.656926952141px 949.2392947103275px',
							'920.656926952141px 949.2392947103275px',
							'922.6156171284634px 949.2392947103275px',
							'923.7618136020151px 949.2392947103275px',
							'926.5475062972292px 950.55959697733px',
							'927.9403526448363px 950.6176322418136px',
							'927.9403526448363px 950.6176322418136px',
							'932.3655415617128px 952.0104785894207px',
							'935.0641813602015px 952.0104785894207px',
							'937.7192947103274px 952.0104785894207px',
							'946.9323929471033px 953.9546599496222px',
							'946.9323929471033px 953.9546599496222px',
							'951.8508816120907px 953.9546599496222px',
							'957.8430226700252px 953.9546599496222px',
							'957.8430226700252px 953.9546599496222px',
							'960.4691183879094px 955.1588916876574px',
							'972.4679093198993px 955.3475062972292px',
							'972.4679093198993px 955.3475062972292px',
							'984.3796473551637px 955.3475062972292px',
							'992.4030226700252px 955.3475062972292px',
							'992.4030226700252px 955.3475062972292px',
							'996.6250881612091px 955.3475062972292px',
							'998.8304282115869px 955.3475062972292px',
							'1001.0357682619647px 955.3475062972292px',
							'1021.855919395466px 957.6253904282116px',
							'1030.0388916876575px 958.5684634760705px',
							'1046.8691183879093px 959.7146599496222px',
							'1051.6860453400504px 959.7291687657431px',
							'1053.2384886649875px 959.7291687657431px',
							'1054.71838790932px 959.7291687657431px',
							'1054.71838790932px 959.7291687657431px',
							'1058.6792947103274px 959.7291687657431px',
							'1058.6792947103274px 959.7291687657431px',
							'1062.6111838790932px 959.7291687657431px',
							'1066.8912846347607px 959.7291687657431px',
							'1066.8912846347607px 959.7291687657431px',
							'1068.3566750629723px 959.7291687657431px',
							'1072.0709319899245px 959.7291687657431px',
							'1072.0709319899245px 959.7291687657431px',
							'1074.784080604534px 959.7291687657431px',
							'1077.424685138539px 959.7291687657431px',
							'1077.424685138539px 959.7291687657431px',
							'1079.8766750629723px 959.7291687657431px',
							'1083.474861460957px 959.7291687657431px',
							'1083.474861460957px 959.7291687657431px',
							'1086.289571788413px 959.7291687657431px',
							'1087.6243828715365px 959.7291687657431px',
							'1088.95919395466px 959.7291687657431px',
							'1093.1957682619648px 959.7291687657431px',
							'1093.1957682619648px 959.7291687657431px',
							'1100.0294206549117px 959.7291687657431px',
							'1102.974710327456px 959.7291687657431px',
							'1102.974710327456px 959.7291687657431px',
							'1105.296120906801px 959.7291687657431px',
							'1105.296120906801px 959.7291687657431px',
							'1106.3407556675063px 959.7291687657431px',
							'1106.3407556675063px 959.7291687657431px',
							'1107.4144080604533px 959.7291687657431px',
							'1109.6197481108313px 959.7291687657431px',
							'1109.6197481108313px 959.7291687657431px',
							'1113.696725440806px 959.7291687657431px',
							'1113.696725440806px 959.7291687657431px',
							'1116.0181360201511px 959.7291687657431px',
							'1116.0181360201511px 959.7291687657431px',
							'1118.049370277078px 959.7291687657431px',
							'1118.049370277078px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1119.152040302267px 959.7291687657431px',
							'1115.5103274559194px 959.7291687657431px',
							'1049.3936523929472px 959.7291687657431px',
							'966.3742065491184px 959.7291687657431px',
							'851.8851385390428px 959.7291687657431px',
							'737.3960705289672px 978.576120906801px',
							'634.1513350125945px 1024.4529974811082px',
							'536.0717380352645px 1076.6267002518891px',
							'444.2889672544081px 1133.9655415617128px',
							'356.88785894206546px 1183.3825692695214px',
							'316.94508816120907px 1207.9750125944583px',
							'268.5872040302267px 1247.569571788413px',
							'228.42680100755666px 1281.9699748110831px',
							'185.46619647355163px 1328.4562216624686px',
							'158.37823677581864px 1363.1758186397985px',
							'138.63173803526448px 1386.462468513854px',
							'117.27476070528967px 1414.928765743073px',
							'100.54609571788413px 1441.233249370277px',
							'80.79959697732997px 1464.5198992443325px',
							'61.05309823677582px 1487.806549118388px',
							'33.84906801007557px 1514.9670528967254px',
							'8.922921914357683px 1539.8641813602014px',
							'-28.538841309823678px 1577.2969269521411px',
							'-63.28745591939546px 1607.9250377833753px',
							'-88.7649370277078px 1637.4649874055415px',
							'-123.51355163727959px 1664.5239294710327px',
							'-146.82921914357684px 1684.241410579345px',
							'-170.14488664987405px 1703.9588916876573px',
							'-191.29874055415618px 1719.0480604534005px',
							'-213.00392947103273px 1734.6740554156172px',
							'-234.15778337531486px 1749.76322418136px',
							'-245.5326952141058px 1758.6281108312342px',
							'-260.447758186398px 1766.0711335012595px',
							'-271.8226700251889px 1774.9360201511336px',
							'-279.6574307304786px 1780.783073047859px',
							'-291.03234256926953px 1785.2082619647356px',
							'-296.37158690176324px 1788.559798488665px',
							'-301.71083123425694px 1791.9113350125945px',
							'-309.5455919395466px 1795.7996977329974px',
							'-320.92050377833755px 1798.2807052896726px',
							'-332.29541561712847px 1802.7058942065491px',
							'-351.83879093198993px 1808.2047355163727px',
							'-376.01047858942064px 1817.2582367758187px',
							'-398.38307304785894px 1827.182267002519px',
							'-409.75798488664987px 1836.047153652393px',
							'-421.1328967254408px 1844.912040302267px',
							'-425.0502770780856px 1848.814911838791px',
							'-437.86156171284637px 1864.0636775818639px',
							'-443.7376322418136px 1871.869420654912px',
							'-447.11818639798486px 1877.1796473551638px',
							'-452.45743073047856px 1882.4898740554156px',
							'-453.87929471032743px 1885.3045843828716px',
							'-455.3011586901763px 1886.7119395465995px',
							'-455.3011586901763px 1886.7119395465995px',
							'-456.3748110831234px 1886.7119395465995px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
